import { Injectable } from '@angular/core';
import { ToastService } from '@skylab-angular-shared/ui';
import { FormState } from '../form-state';
import { FormStateHandler } from './form-state-handler';

export interface ValidationErrorContext {
    message: string;
}

@Injectable({providedIn: 'root'})
export class ValidationErrorHandler extends FormStateHandler<ValidationErrorContext> {
    public constructor(public readonly toastService: ToastService) {
        super();
    }

    protected get formState(): FormState {
        return FormState.ValidationError;
    }

    protected handle(ctx: ValidationErrorContext): void {
        if (!ctx) return;

        this.toastService.showAsync({
            type: 'error',
            text: ctx.message,
        });
    }
}
